module.exports = __webpack_public_path__ + "img/1754540724521-WhatsApp Image 2025-08-07 at 12.23.06_d5006ea1.jpg.0e6e2b77.webp";